import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useTranslation } from "react-i18next";
import { Disclosure } from "./modules/Disclosure/Disclosure";
import { meta } from "./utils";

export interface IAppProps {
    ver?: string;
}

const recaptchaKey = meta("recaptcha-key"); 

export const App: React.FunctionComponent<IAppProps> = () => {
    const { i18n } = useTranslation();
    const lang = i18n.language.substring(0, 2);
return <GoogleReCaptchaProvider
reCaptchaKey={recaptchaKey}
language={lang}
useRecaptchaNet={true}
useEnterprise={false}
scriptProps={{
    async: false, // optional, default to false,
    defer: false, // optional, default to false
    appendTo: 'head', // optional, default to "head", can be "head" or "body",
    nonce: undefined // optional, default undefined
}}
container={{
parameters: {
    badge: 'bottomright', // optional, default undefined
    theme: undefined // 'dark', // optional, default undefined
}
}}
><Disclosure /></GoogleReCaptchaProvider>
}
